/* istanbul ignore file */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, LogicBuilder, LogicBuilderEmailPreviewData, Project } from '../../models';

@Injectable({
    providedIn: 'root'
})

export class LogicBuilderDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient
    ) {
        super(_httpClient);
    }

    createLogicBuilder(app: App, logicBuilder: LogicBuilder): Observable<void> {
        const url = `${this.route}${app.id}/projects/${logicBuilder.projectId}/logic-builders`;
        return this.httpPost(url, logicBuilder);
    }

    updateLogicBuilder(app: App, logicBuilder: LogicBuilder): Observable<void> {
        const url = `${this.route}${app.id}/projects/${logicBuilder.projectId}/logic-builders/${logicBuilder.id}`;
        return this.httpPut(url, logicBuilder);
    }

    deleteLogicBuilder(app: App, logicBuilder: LogicBuilder): Observable<void> {
        const url = `${this.route}${app.id}/projects/${logicBuilder.projectId}/logic-builders/${logicBuilder.id}`;
        return this.httpDelete(url);
    }

    getLogicBuildersByProject(app: App, project: Project): Observable<LogicBuilder[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/logic-builders`;
        return this.httpGet(url);
    }

    toggleActiveLogicBuilder(app: App, logicBuilder: LogicBuilder): Observable<LogicBuilder> {
        const url = `${this.route}${app.id}/projects/${logicBuilder.projectId}/logic-builders/${logicBuilder.id}/activate`;
        return this.httpPut(url, logicBuilder);
    }

    getLogicBuilderPreview(app: App, project: Project, LogicBuilderEmailPreviewData: LogicBuilderEmailPreviewData): Observable<any> {
        const url = `${this.route}${app.id}/projects/${project.id}/logic-builders/preview`;
        return this.httpPost(url, LogicBuilderEmailPreviewData);
    }
}
